/**
 * WordPress Dependencies
 */
import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';
import {
	InnerBlocks,
	useBlockProps,
	InspectorControls,
} from '@wordpress/block-editor';

import { TextControl, PanelBody } from '@wordpress/components';

import './variations';

registerBlockType( 'web3coingate/verification-output', {
	apiVersion: 2,
	title: __( 'Verification Output', 'web3-coin-gate' ),
	description: __( 'Token gate verficiation output' ),

	attributes: {
		type: {
			type: 'string',
			enum: [ 'success', 'failure' ],
		},
		minimumTokenCount: {
			type: 'number',
			default: 1,
		},
	},
	supports: {
		inserter: false,
		align: [ 'full' ],
	},
	edit: ( props ) => {
		const labels = {
			success: __( 'Success Verification Output', 'web3-coin-gate' ),
			failure: __( 'Failure Verification Output', 'web3-coin-gate' ),
		};

		const descriptions = {
			success: __(
				'Please create verification output that should be displayed when the token is valid.',
				'web3-coin-gate'
			),
			failure: __(
				'Please create verification output that should be displayed when the token is invalid.',
				'web3-coin-gate'
			),
		};

		return (
			<>
				<div
					{ ...useBlockProps( {
						className:
							'coingate-verification-block type-' +
							props.attributes.type,
					} ) }
				>
					<h3>{ labels[ props.attributes.type ] }</h3>
					<p>{ descriptions[ props.attributes.type ] }</p>

					<div className="coingate-verification-content">
						<InnerBlocks
							templateLock={ false }
							renderAppender={ InnerBlocks.ButtonBlockAppender }
						/>
					</div>
				</div>
				<InspectorControls>
					{ props.attributes?.type === 'success' && (
						<PanelBody
							title={ __( 'Coin Gate', 'web3-coin-gate' ) }
						>
							<TextControl
								type="number"
								min={ 1 }
								value={ props.attributes?.minimumTokenCount }
								onChange={ ( newMinimumTokenCount ) => {
									props.setAttributes( {
										minimumTokenCount: Number(
											newMinimumTokenCount
										),
									} );
								} }
								label={ __(
									'Minimum tokens owned',
									'web3-coin-gate'
								) }
								help={ __(
									'Number of minimum tokens that should be available in the user wallet to display this particular success output.',
									'web3-coin-gate'
								) }
							/>
						</PanelBody>
					) }
				</InspectorControls>
			</>
		);
	},
	save: ( props ) => {
		return (
			<div
				{ ...useBlockProps.save( {
					className: 'coingate-verification-block',
				} ) }
			>
				<InnerBlocks.Content />
			</div>
		);
	},
} );
